/**
 * Check if icon contains multiple colours.
 * If true, the icon probably needs a white background to look okay.
 *
 * @param icon Icon key
 * @returns true if icon contains miltiple colours
 */
const isMultiColorIcon = (icon) => ['google'].includes(icon);
export default isMultiColorIcon;
